import {
  Button,
  Modal,
} from "reactstrap";
import React, { useState } from "react";

import PropTypes from "prop-types";

const MessageDialog = ({isOpen,title,message,hide}) => {
  return (
    <>
      {
        <Modal
          isOpen={isOpen}
          scrollable={true}
          backdrop={"static"}
          centered={true}
        >
          <div className="modal-header">
            <h5 className="modal-title">
              {title}
            </h5>
          </div>
          <div className="modal-body">
            <h5 className="mt-3">{message}</h5>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success"
              onClick={() => hide()}
            >
              {/* <i className="fas fa-times"></i> */}
              {/* &nbsp;  */}
              OK
            </button>
          </div>
        </Modal>
      }
    </>
  )
}

MessageDialog.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  hide:PropTypes.func
};
export const useModalShowMessage = () => {
  const [showMessage, setShowMessage] = useState(false);
  const [bodyMessageModal, setBodyMessageModal] = useState(null);
  const [titleMessageModal, setTitleMessageModal] = useState(null);
  function toggleModalMessage(message,title = 'Information') {
    setBodyMessageModal(message);
    setTitleMessageModal(title)
    setShowMessage(!showMessage);
  }
  return {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal
  };
};

export default MessageDialog;